/* eslint-disable max-nested-callbacks */
/* eslint-disable complexity */
/* eslint-disable max-lines */
/* eslint-disable max-statements */
import { useEffect } from "react"
import { OptionItemType } from "../../../../../../../_webui/layout/components/Select/models"
import { GeneralCode } from "../../../../../../../constant/GeneralCode"
import { Routers } from "../../../../../../../constant/Routers"
import { AxiosErrorType } from "../../../../../../../infrastructure/axiosError/models"
import { departmentsApi } from "../../../../../../../infrastructure/handlers/departments"
import { DepartmentsResType } from "../../../../../../../infrastructure/handlers/departments/models"
import { generalMastersApi } from "../../../../../../../infrastructure/handlers/generalMasters"
import { GeneralMastersResType } from "../../../../../../../infrastructure/handlers/generalMasters/models"
import { backToLogin } from "../../../../../../../utils/backToLogin"
import { getValueByLanguage } from "../../../../../../../utils/getValueByLanguage"
import { replaceString } from "../../../../../../../utils/replaceString"
import { setFieldsErrors } from "../../../../../../../utils/setFieldsErrors"
import { travelerApi } from "../../../../../travelers/apis"
import { scheduleApi } from "../../../../apis"
import { TravelerInfoResponseType } from "../../../../components/add/Form/ContentCollapse/Personal/models"
import { Variables } from "../../../../constants/add/variables"
import {
  ScheduleDataType,
  ScheduleGetLocationToSendMailResType,
} from "../../../../models/add"
import { ScheduleDataAddType } from "../../../../models/add/DataAdd"
import { getScheduleDataAdd } from "../../../add/utils/getDataAdd"
import { getTravelerInfo } from "../../../add/utils/getTravelerInfo"
import { useVariables } from "../useVariables"
import { CitiesResType } from "../../../../../../../infrastructure/handlers/countries/models"
import { countriesApi } from "../../../../../../../infrastructure/handlers/countries"
import { SelectItems } from "../../../../../../../constant/SelectItems"
import { TravelersDetailResType } from "../../../../../travelers/models/detail"
import { Translate } from "../../../../../../../constant/Translate"
import { setNameRowDetail } from "../../../add/utils/setNameRowDetail"
import { translateMessage } from "../../../../../../../utils/translateMessage"
import { getWorkPlaceLocation } from "../../../../../../../utils/getWorkPlaceLocation"
import { Variables as TravelerEditVariables } from "../../../../../travelers/constants/edit/variables"
import { UseSchedulesEditType } from "../../../../models/edit"

const { SCR211, SCR215, SCR920 } = Routers
const { MESSAGE_E0138 } = Translate
const { OTHER_CITY_SELECT_ITEMS } = SelectItems
const { DPTD, DPTD_SUBADMIN, PPTV, PPTV_SCR212 } = GeneralCode
const { DPTD_OTHERS_STAFF_NUMBER, E0017, E0105, E0106 } = Variables
const { KEYS_ACCOMPANYING_FAMILY } = TravelerEditVariables

export const useSchedulesEdit = (): UseSchedulesEditType => {
  const {
    allCountries,
    assignmentValidMsg,
    breadcrumbItems,
    dataSubmit,
    defaultActiveKey,
    departments,
    detailColumnsFirst,
    detailColumnsSecond,
    detailDataSource,
    detailIndexIdentity,
    detailIndexTabActive,
    detailRowSelection,
    detailSelectedRowKeys,
    detailTabsItems,
    detailValidMsg,
    dispatchType,
    form,
    getFlightInfo,
    getInitialValues,
    getPurposeTravelList,
    goToSchedulesClone,
    handleAddDetailItem,
    handleAddLodgingItem,
    handleAddStayItem,
    handleCheckHiredLocally,
    handleCheckInsuranceAndUrgent,
    handleCheckSubmitValidate,
    handleCheckTwoWay,
    handleDeleteDetailItem,
    handleDeleteLodgingItem,
    handleDeleteStayItem,
    handleError,
    handleErrorValidate,
    handleSetDetailRequiredFields,
    handleSetLodgingRequiredFields,
    handleSetStayRequiredFields,
    id,
    isAccompanyingFamily,
    isActiveBumon,
    isDifferentInfoChecked,
    isDisabledSubmit,
    isHiredLocally,
    isInsuranceAndUrgent,
    isInsuranceRequired,
    isLoadingLayout,
    isNotAccessScreen,
    isOpen,
    isOpenRoundTrip,
    isOtherStaffNumber,
    isRequiredItemTableByDate,
    isRequiredItemTableByPPTV,
    isRequiredItemTableDetails,
    isRequiredItemTableLodgings,
    isSchedulesAdd,
    isSchedulesEdit,
    isSubmitValidate,
    isTableLoading,
    isTwoWay,
    isValidForm,
    isVisibleBtn,
    isVisibleBtnCancel,
    isVisibleBtnConfirm,
    isVisibleBtnCopy,
    isVisibleOtherRemarks,
    listPPTVIsValue3Equal1,
    listPPTVIsValue4Equal2,
    locationToSendMailList,
    lodgingColumns,
    lodgingDataSource,
    lodgingIndexIdentity,
    lodgingIndexTabActive,
    lodgingRowSelection,
    lodgingSelectedRowKeys,
    lodgingTabsItems,
    lodgingValidMsg,
    notificationPersonAddressNameList,
    onBlur,
    onCancel,
    onCancelRoundTrip,
    onChangeCollapse,
    onChangeDate,
    onChangeDifferentInfo,
    onChangeTravelerBumonCd,
    onChangeTravelPurpose,
    onClickDetailTab,
    onClickLodgingTab,
    onClickStayTab,
    onDispatchTypeDetailChange,
    onFinish,
    onKeyDown,
    onOkRoundTrip,
    onValidateChangeDate,
    onValuesChange,
    pathname,
    purposeTravelList,
    push,
    scheduleDetails,
    scheduleLodgings,
    schedulesData,
    scheduleStays,
    setAssignmentValidMsg,
    setDataScheduleDetails,
    setDataScheduleLodgings,
    setDataScheduleStays,
    setDefaultCountries,
    setDepartments,
    setDetailValidMsg,
    setDispatchType,
    setDispatchTypeDetailRes,
    setIsAccompanyingFamily,
    setIsActiveBumon,
    setIsDifferentInfoChecked,
    setIsLoadingLayout,
    setIsOtherStaffNumber,
    setIsRequiredItemTableByPPTV,
    setIsRequiredItemTableLodgings,
    setIsTableLoading,
    setIsTwoWay,
    setLocationToSendMailList,
    setLodgingValidMsg,
    setNotificationPersonAddressNameList,
    setPurposeTravelRes,
    setSchedulesData,
    setTravelerBumonCd,
    setTravelerId,
    setWorkPlaceCountryCode,
    setWorkPlaceLocation,
    state,
    stayColumns,
    stayDataSource,
    stayIndexIdentity,
    stayIndexTabActive,
    stayRowSelection,
    staySelectedRowKeys,
    stayTabsItems,
    transportationList,
    travelerBumonCd,
    travelerId,
  } = useVariables()

  const goBack = () => {
    // 「SCR211_渡航予定情報の参照画面」に戻る。
    // 「SCR210_渡航予定情報の一覧画面」に戻る。
    const pathname = state?.isFromSCR211
      ? replaceString(SCR211, id)
      : state?.sourceURL && replaceString(SCR215, id) !== state.sourceURL
      ? state?.sourceURL
      : state?.schedulesURL
      ? state.schedulesURL
      : SCR920
    push({
      pathname,
      state: { ...state, sourceURL: pathname },
    })
  }

  const onOk = async () => {
    const check = handleCheckTwoWay()
    setIsTwoWay(check)
    if (check) {
      setTimeout(() => {
        document.querySelectorAll(".ant-collapse-item")[4]?.scrollIntoView()
      }, 300)
    } else if (travelerId) {
      const data: ScheduleDataAddType = await getScheduleDataAdd({
        allCountries,
        dataSubmit,
        departments,
        detailDataSource,
        detailIndexIdentity,
        id,
        isHiredLocally,
        isOtherStaffNumber,
        isSchedulesAdd,
        isSchedulesEdit,
        locationToSendMailList,
        lodgingIndexIdentity,
        notificationPersonAddressNameList,
        purposeTravelList,
        schedulesData,
        stayIndexIdentity,
        transportationList,
        travelerId,
      })
      // データをデータベースに登録する。
      setAssignmentValidMsg("")
      setIsLoadingLayout(true)
      scheduleApi
        .updateSchedule(id, data)
        .then((res) => {
          // 「SCR215_渡航予定情報の変更後画面」に遷移する。
          push(replaceString(SCR215, res.travelScheduleId), {
            ...state,
            isFromSCR214: true,
            sourceURL: pathname,
          })
        })
        .catch((error: AxiosErrorType) => {
          const data = error?.debug?.response?.data
          const messages = [E0017, E0105, E0106]
          const entityName = error?.debug?.response?.data?.entityName
          if (data.message === "E0138") {
            const _entityName = entityName.split(",")
            for (let index = 0; index < _entityName.length; index++) {
              form.setFields([
                {
                  errors: [MESSAGE_E0138],
                  name: `${setNameRowDetail(
                    +_entityName[index],
                  )}.departureDate`,
                },
              ])
            }
            form.scrollToField(
              `${setNameRowDetail(+_entityName[0])}.departureDate`,
            )
          } else {
            if (entityName && !["detail", "lodging"].includes(entityName))
              setFieldsErrors(error, form)
            else if (messages.includes(data?.message)) {
              if (entityName === "detail") {
                setDetailValidMsg(translateMessage(`MESSAGE.${data.message}`))
              } else if (entityName === "lodging") {
                setLodgingValidMsg(translateMessage(`MESSAGE.${data.message}`))
              } else {
                handleErrorValidate(data.message, entityName)
              }
            } else handleError(error)
          }
        })
        .finally(() => {
          setIsLoadingLayout(false)
        })
    }
  }

  const getSchedule = async (id: string) => {
    return scheduleApi
      .getSchedule(id)
      .then((res: ScheduleDataType) => res)
      .catch((error: AxiosErrorType) => {
        handleError(error)
      })
  }

  const getData = () => {
    const getDispatchTypeDetailListAPI: Promise<GeneralMastersResType[]> =
      generalMastersApi.getGeneralMaster(DPTD)
    // APIを呼び出し、渡航目的一覧情報を取得し
    const getPurposeTravelListAPI: Promise<GeneralMastersResType[]> =
      generalMastersApi.getGeneralMaster(PPTV)
    // APIを呼び出し、部門一覧情報を取得し
    const getDepartmentsAPI: Promise<DepartmentsResType[]> =
      departmentsApi.getAllDepartments()
    const getLocationToSendMail: Promise<
      ScheduleGetLocationToSendMailResType[]
    > = scheduleApi.getLocationToSendMail()

    Promise.all([
      getDispatchTypeDetailListAPI,
      getPurposeTravelListAPI,
      getDepartmentsAPI,
      getLocationToSendMail,
    ])
      .then(async (res) => {
        const optionItemDepartment: OptionItemType[] = res[2].map((item) => ({
          text: String(
            getValueByLanguage(
              item.departmentNameJapan,
              item.departmentNameEnglish,
            ),
          ),
          value: item.bumonCd,
        }))
        const optionItemLocationToSendMail: OptionItemType[] = res[3].map(
          (item) => ({
            text: String(
              getValueByLanguage(item.locationNameJp, item.locationNameEn),
            ),
            value: item.locationId,
          }),
        )

        setDepartments(optionItemDepartment)
        setLocationToSendMailList(optionItemLocationToSendMail)

        setDispatchTypeDetailRes(res[0])
        setPurposeTravelRes(res[1])

        setIsTableLoading(true)

        const _scheduleData = await getSchedule(id)

        if (_scheduleData) {
          const _travelerId = _scheduleData.info?.travelerId
          setTravelerId(_travelerId)

          travelerApi
            .getTravelerBase(_travelerId)
            .then((travelerInfoRes: TravelerInfoResponseType) => {
              const travelerInfo = getTravelerInfo(travelerInfoRes)
              form.setFieldsValue(travelerInfo)
              // APIを呼び出し、データベースから渡航者情報を取得する。
              travelerApi
                .getTravelerDetails(travelerInfoRes.travelerId)
                .then((travelerDetailsRes: TravelersDetailResType) => {
                  handleCheckInsuranceAndUrgent(travelerDetailsRes)
                  const {
                    workPlaceCountry,
                    othersStaffNumber,
                    workPlaceLocation,
                  } = travelerDetailsRes.detail
                  const _workPlaceLocation =
                    getWorkPlaceLocation(workPlaceLocation)
                  form.setFieldValue("workPlaceLocation", _workPlaceLocation)
                  setWorkPlaceLocation(workPlaceLocation)
                  setWorkPlaceCountryCode(workPlaceCountry)
                  setTravelerBumonCd(travelerDetailsRes.base.bumonCd)
                  setIsOtherStaffNumber(!!othersStaffNumber)

                  setIsAccompanyingFamily(
                    KEYS_ACCOMPANYING_FAMILY.includes(
                      travelerInfoRes.dispatchTypeDetailId,
                    ),
                  )

                  const optionItem: OptionItemType[] = res[0].map((item) => ({
                    text: String(getValueByLanguage(item.value1, item.value2)),
                    value: item.key1,
                  }))
                  const dispatchTypeDetailId = DPTD_SUBADMIN.includes(
                    travelerInfoRes.dispatchTypeDetailId,
                  )
                    ? [travelerInfoRes.dispatchTypeDetailId]
                    : []
                  const _dispatchType = optionItem.filter((item) =>
                    [
                      ...DPTD_OTHERS_STAFF_NUMBER,
                      ...dispatchTypeDetailId,
                    ].includes(String(item.value)),
                  )
                  setDispatchType(_dispatchType)

                  getFlightInfo(_travelerId)
                  // APIを呼び出し、都市一覧情報を取得する。
                  countriesApi
                    .getCitiesByCountry(workPlaceCountry)
                    .then((res: CitiesResType[]) => {
                      const data = res.map((item) => ({
                        text: item.cityDistrict,
                        value: item.cityCode,
                      }))
                      setDefaultCountries([...data, OTHER_CITY_SELECT_ITEMS])
                    })
                    .catch((error: AxiosErrorType) => {
                      handleError(error)
                    })

                  travelerApi
                    .getSubadminList(travelerDetailsRes.base.bumonCd)
                    .then(async (resp) => {
                      const optionItemNotificationPersonAddressNameList: OptionItemType[] =
                        resp.map((item) => ({
                          text: `${item.fullName}（${item.loginId}）`,
                          value: item.loginId,
                        }))
                      setNotificationPersonAddressNameList(
                        optionItemNotificationPersonAddressNameList,
                      )

                      const _purposeTravelList = getPurposeTravelList({
                        dispatchTypeDetailId:
                          travelerInfoRes?.dispatchTypeDetailId,
                        dispatchTypeDetailRes: res[0],
                        purposeTravelRes: res[1],
                        workPlaceLocation,
                      })

                      if (_purposeTravelList) {
                        const initialValues = getInitialValues(
                          optionItemDepartment,
                          optionItemNotificationPersonAddressNameList,
                          _purposeTravelList,
                          _scheduleData.info,
                        )
                        handleCheckHiredLocally(initialValues.travelPurposeId)
                        form.setFieldsValue(initialValues)
                      }
                    })
                    .catch((error: AxiosErrorType) => {
                      handleError(error)
                    })
                    .finally(() => {
                      form.setFieldsValue({
                        detailSortType: schedulesData.info.detailSortType,
                        travelerBumonCd: travelerDetailsRes.base.bumonCd,
                        travelerDispatchTypeDetailId:
                          travelerDetailsRes.base.dispatchTypeDetailId,
                      })
                      setIsLoadingLayout(false)
                    })
                })
                .catch((error: AxiosErrorType) => {
                  handleError(error)
                })
            })
            .catch((error: AxiosErrorType) => {
              handleError(error)
            })

          setSchedulesData(_scheduleData)
          onValidateChangeDate()
          setIsRequiredItemTableLodgings(
            !PPTV_SCR212.includes(_scheduleData?.info?.travelPurposeId),
          )
          if (_scheduleData.info?.differentInforCheck)
            setIsDifferentInfoChecked(true)

          if (!_scheduleData.details.length) handleAddDetailItem()
          if (!_scheduleData.lodgings.length) handleAddLodgingItem()
          if (!_scheduleData.stays.length) handleAddStayItem()
        }

        setIsTableLoading(false)
      })
      .catch((error: AxiosErrorType) => {
        handleError(error)
      })
  }

  useEffect(() => {
    onValuesChange()
  })

  useEffect(() => {
    if (scheduleDetails.length) setDataScheduleDetails()
  }, [scheduleDetails])

  useEffect(() => {
    if (scheduleLodgings.length) setDataScheduleLodgings()
  }, [scheduleLodgings])

  useEffect(() => {
    if (scheduleStays.length) setDataScheduleStays()
  }, [scheduleStays])

  useEffect(() => {
    const timeId = setTimeout(() => {
      handleSetDetailRequiredFields()
      handleSetLodgingRequiredFields()
      handleSetStayRequiredFields()
      onValidateChangeDate()
    }, 100)

    return () => clearTimeout(timeId)
  }, [isHiredLocally, isRequiredItemTableByPPTV])

  useEffect(() => {
    const timeId = setTimeout(() => {
      handleSetDetailRequiredFields()
      onValidateChangeDate()
    }, 100)

    return () => clearTimeout(timeId)
  }, [detailDataSource])

  useEffect(() => {
    const timeId = setTimeout(() => {
      handleSetLodgingRequiredFields()
    }, 100)

    return () => clearTimeout(timeId)
  }, [
    isRequiredItemTableByDate,
    isRequiredItemTableByPPTV,
    isRequiredItemTableLodgings,
    lodgingDataSource,
  ])

  useEffect(() => {
    const timeId = setTimeout(() => {
      handleSetStayRequiredFields()
    }, 100)

    return () => clearTimeout(timeId)
  }, [stayDataSource])

  useEffect(() => {
    if (schedulesData.info.travelPurposeId) {
      if (
        listPPTVIsValue3Equal1.length &&
        listPPTVIsValue3Equal1.includes(schedulesData.info.travelPurposeId)
      ) {
        if (!form.getFieldValue("bumonCd")) {
          form.setFieldValue("bumonCd", travelerBumonCd)
        }
        setIsActiveBumon(true)
      }
      if (
        listPPTVIsValue4Equal2.length &&
        listPPTVIsValue4Equal2.includes(schedulesData.info.travelPurposeId)
      )
        setIsRequiredItemTableByPPTV(false)
    }
  }, [
    listPPTVIsValue3Equal1,
    listPPTVIsValue4Equal2,
    schedulesData.info.travelPurposeId,
  ])

  useEffect(() => {
    handleCheckSubmitValidate()
  }, [isSubmitValidate])

  useEffect(() => {
    // ユーザーの画面アクセス許可チェックを処理する。
    if (isNotAccessScreen) {
      // 「SCR973_エラー情報の表示画面」に遷移する。
      const { pathname, state } = backToLogin()
      push({ pathname, state })
    } else {
      getData()
    }
  }, [])

  return {
    assignmentValidMsg,
    breadcrumbItems,
    defaultActiveKey,
    departments,
    detailColumnsFirst,
    detailColumnsSecond,
    detailDataSource,
    detailIndexTabActive,
    detailRowSelection,
    detailSelectedRowKeys,
    detailTabsItems,
    detailValidMsg,
    dispatchType,
    form,
    goBack,
    goToSchedulesClone,
    handleAddDetailItem,
    handleAddLodgingItem,
    handleAddStayItem,
    handleDeleteDetailItem,
    handleDeleteLodgingItem,
    handleDeleteStayItem,
    isAccompanyingFamily,
    isActiveBumon,
    isDifferentInfoChecked,
    isDisabledSubmit,
    isHiredLocally,
    isInsuranceAndUrgent,
    isInsuranceRequired,
    isLoadingLayout,
    isOpen,
    isOpenRoundTrip,
    isOtherStaffNumber,
    isRequiredItemTableDetails,
    isSchedulesAdd,
    isSchedulesEdit,
    isSubmitValidate,
    isTableLoading,
    isTwoWay,
    isValidForm,
    isVisibleBtn,
    isVisibleBtnCancel,
    isVisibleBtnConfirm,
    isVisibleBtnCopy,
    isVisibleOtherRemarks,
    locationToSendMailList,
    lodgingColumns,
    lodgingDataSource,
    lodgingIndexTabActive,
    lodgingRowSelection,
    lodgingSelectedRowKeys,
    lodgingTabsItems,
    lodgingValidMsg,
    notificationPersonAddressNameList,
    onBlur,
    onCancel,
    onCancelRoundTrip,
    onChangeCollapse,
    onChangeDate,
    onChangeDifferentInfo,
    onChangeTravelPurpose,
    onChangeTravelerBumonCd,
    onClickDetailTab,
    onClickLodgingTab,
    onClickStayTab,
    onDispatchTypeDetailChange,
    onFinish,
    onKeyDown,
    onOk,
    onOkRoundTrip,
    onValuesChange,
    purposeTravelList,
    stayColumns,
    stayDataSource,
    stayIndexTabActive,
    stayRowSelection,
    staySelectedRowKeys,
    stayTabsItems,
  }
}
